import { PlannerMapDataElement } from 'components/common/types/Planner.types';

export const MAP_ELEMENT_RADIUS_SCALE = 0.15;

const FRAME_ELEMENT_SIZE = 64;
const SINGULAR_MAP_ELEMENT_SIZE = 124;
const MIN_MAP_ELEMENT_SIZE = 140;
const MAX_MAP_ELEMENT_SIZE = 240;

const normalizeSize = ({
  min,
  max,
  count,
  maxAssets,
}: {
  min: number;
  max: number;
  count: number;
  maxAssets: number;
}): number => {
  return min + (max - min) * Math.min(count / maxAssets, 1);
};

export const getMapElementSize =
  (scale = 1, maxAssets = 0) =>
  (data: PlannerMapDataElement) => {
    if (!maxAssets) return 0;

    const assetCount = data.properties.point_count ?? 0;

    if (!assetCount) return Math.floor(FRAME_ELEMENT_SIZE * scale);

    if (assetCount < 10) {
      return Math.floor(
        normalizeSize({ min: SINGULAR_MAP_ELEMENT_SIZE, max: MAX_MAP_ELEMENT_SIZE, count: assetCount, maxAssets }) *
          scale,
      );
    }

    return Math.floor(
      normalizeSize({ min: MIN_MAP_ELEMENT_SIZE, max: MAX_MAP_ELEMENT_SIZE, count: assetCount, maxAssets }) * scale,
    );
  };
